export default "__VITE_ASSET__CVrhiBSi__"